ListControlDirective.$inject = ['$location'];
function ListControlDirective($location) {
    return {
        link: function (scope, elem, attrs) {
            var DEFAULT_COUNT = 20;
            scope.$watch(function () {
                return $location.search();
            }, function (params, old) {
                if (params === old || params.count !== old.count || params.page !== old.page) {
                    fetch(params);
                }
            }, true);
            function fetch(params) {
                var page = params.page || 1;
                var count = Number(params.count) || DEFAULT_COUNT;
                scope.$emit('refreshList', [{
                        page: page,
                        count: count
                    }]);
            }
        }
    };
}
angular.module('profumo.core.directives.list-control', [])
    .directive('listControl', ListControlDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/ListControlDirective.js
// module id = 463
// module chunks = 0